(() => {
  const initializePayPoWidget = (widget) => {
    if (!widget || widget.dataset.initialized === 'true') return;

    const sectionId = widget.dataset.sectionId;
    const trigger = widget.querySelector('[data-paypo-trigger]');
    const dialog = widget.querySelector('[data-paypo-dialog]');
    const closeButton = widget.querySelector('[data-paypo-close]');
    const iframe = widget.querySelector('[data-paypo-iframe]');

    if (!sectionId || !trigger || !dialog || !closeButton || !iframe) return;

    widget.dataset.initialized = 'true';

    document
      .querySelectorAll(`[data-paypo-trigger="${sectionId}"]`)
      .forEach((element) => {
        if (element !== trigger) {
          element.remove();
        }
      });

    const target =
      document.getElementById(
        'projector_points_wrapper'
      );

    const isPdpV2 =
      widget.classList.contains(
        'paypo-widget--pdp-v2'
      ) ||
      Boolean(
        widget.closest(
          '.psv5__paylater'
        )
      );

    if (
      target &&
      !isPdpV2
    ) {
      target.before(trigger);
    }

    const loadIframe = () => {
      if (
        !iframe.src &&
        iframe.dataset.src
      ) {
        iframe.src =
          iframe.dataset.src;
      }
    };

    const openDialog = () => {
      loadIframe();

      document.documentElement
        .classList.add(
          'paypo-dialog-open'
        );

      if (
        typeof dialog.showModal ===
        'function'
      ) {
        if (!dialog.open) {
          dialog.showModal();
        }
      } else {
        dialog.setAttribute(
          'open',
          ''
        );
      }

      closeButton.focus();
    };

    const closeDialog = () => {
      if (
        typeof dialog.close ===
          'function' &&
        dialog.open
      ) {
        dialog.close();
      } else {
        dialog.removeAttribute(
          'open'
        );

        document.documentElement
          .classList.remove(
            'paypo-dialog-open'
          );

        trigger.focus();
      }
    };

    trigger.addEventListener(
      'click',
      openDialog
    );

    closeButton.addEventListener(
      'click',
      closeDialog
    );

    dialog.addEventListener(
      'click',
      (event) => {
        if (
          event.target === dialog
        ) {
          closeDialog();
        }
      }
    );

    dialog.addEventListener(
      'close',
      () => {
        document.documentElement
          .classList.remove(
            'paypo-dialog-open'
          );

        trigger.focus();
      }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          dialog.open
        ) {
          closeDialog();
        }
      }
    );
  };

  const initializePayPoWidgets = (
    root = document
  ) => {
    if (
      root.matches?.(
        '[data-paypo-widget]'
      )
    ) {
      initializePayPoWidget(
        root
      );
    }

    root
      .querySelectorAll?.(
        '[data-paypo-widget]'
      )
      .forEach(
        initializePayPoWidget
      );
  };

  initializePayPoWidgets();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializePayPoWidgets(
        event.target
      );
    }
  );
})();